import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Existing Pages
import Home from './pages/Home';
import CablesHome from './pages/CablesHome';
import Products from './pages/Products';
import Catalogue from './pages/Catalogue';
import About from './pages/About';
import Contact from './pages/Contact';

// New Pump Pages
import PumpHome from './pages/PumpHome';
import PumpProducts from './pages/PumpProducts';
import PumpCatalogue from './pages/PumpCatalogue';

// New Steel Pages
import SteelHome from './pages/SteelHome';
import SteelProducts from './pages/SteelProducts';
import SteelCatalogue from './pages/SteelCatalogue';

// Quote Page
import QuoteBuilder from './pages/QuoteBuilder';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          {/* Existing Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/catalogue" element={<Catalogue />} />
          <Route path="/cables" element={<CablesHome />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* New Pump Routes */}
          <Route path="/pumps" element={<PumpHome />} />
          <Route path="/pump-products" element={<PumpProducts />} />
          <Route path="/pump-catalogue" element={<PumpCatalogue />} />
          
          {/* New Steel Routes */}
          <Route path="/steel" element={<SteelHome />} />
          <Route path="/steel-products" element={<SteelProducts />} />
          <Route path="/steel-catalogue" element={<SteelCatalogue />} />
          
          {/* Quote Route */}
          <Route path="/quote" element={<QuoteBuilder />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;